import type { FaireProductEntity } from "../../entity_types/product";

export const p_vw3gyx4avj: FaireProductEntity = {
  token: "p_vw3gyx4avj",
  type: "product",
  name: "winter watercolor workbook",
  brandToken: "b_mmdanrh9jf",
  brandName: "emily lex studio",
  imageUrl:
    "https://cdn.faire.com/fastly/aa176daa23868df5ce3a37494eff59005ae64fa1c6a9ec8a55f93faf680db761.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9cd9fb2621ffea9049b62bcf4d383311ac103dc5951230d28a66a847a7d3c05e.jpeg",
    "https://cdn.faire.com/fastly/02eb77bdca6463679b10835193f96fb8e9a7883f004c3a113902ee55abf2e2a3.jpeg",
    "https://cdn.faire.com/fastly/9a79ba54f7462c8bdcbfeea9fdf6eaa6764fa4fdeca8126da9edb328765f6064.jpeg",
    "https://cdn.faire.com/fastly/c99de54a327886e7a35089607026d021177199bd258d0d2010c92ce46ce8967a.jpeg",
    "https://cdn.faire.com/fastly/770b0b83ef0c705283c390e9c39f98cbb723e18928211afc59b01169c9cb99f1.jpeg",
    "https://cdn.faire.com/fastly/4cc2eb5fd2271d2c24a358d53c84e1fd52bc24a0eaa1cd5fe417b195b8187d99.jpeg",
    "https://cdn.faire.com/fastly/a5ae7896e0e31775f2db864fbccf65dfb261309b5db28f27bf06e3f866713385.jpeg",
  ],
  priceDollars: 12,
  description:
    "Twelve winter illustrations — a snowman, A-frame cabin, fair isle sweater, snow globe, ice skaters, mittens, and more — each pre-outlined with step-by-step instructions. Paintings take about thirty minutes from start to finish, making it approachable for first-time painters and a favorite for gifting.\n\nA strong winter and post-holiday seller. Performs well in mountain-town and cold-weather boutiques. Reorder late autumn.\n",
  tags: [],
  msrpDollars: 24,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-14T07:11:08.439Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
